import api from './api'

/**
 * Serviço de Times/Squads/Tribos
 */
export default {
  /**
   * Lista todos os times do tenant
   * @param {Object} params - Parâmetros de filtro
   * @param {String} params.parentId - ID do time pai (opcional)
   * @returns {Promise}
   */
  list(params = {}) {
    return api.get('/api/teams', { params })
  },

  /**
   * Cria um novo time
   * @param {Object} teamData - Dados do time
   * @returns {Promise}
   */
  create(teamData) {
    return api.post('/api/teams', teamData)
  },

  /**
   * Atualiza um time existente
   * @param {String} id - ID do time
   * @param {Object} teamData - Dados atualizados
   * @returns {Promise}
   */
  update(id, teamData) {
    return api.put(`/api/teams/${id}`, teamData)
  },

  /**
   * Remove um time
   * @param {String} id - ID do time
   * @returns {Promise}
   */
  delete(id) {
    return api.delete(`/api/teams/${id}`)
  },

  /**
   * Lista membros de um time
   * @param {String} id - ID do time
   * @returns {Promise}
   */
  getMembers(id) {
    return api.get(`/api/teams/${id}/members`)
  },

  /**
   * Adiciona membros a um time
   * @param {String} id - ID do time
   * @param {Array<String>} userIds - IDs dos usuários
   * @returns {Promise}
   */
  addMembers(id, userIds) {
    return api.post(`/api/teams/${id}/members`, { userIds })
  },

  /**
   * Remove um membro do time
   * @param {String} id - ID do time
   * @param {String} userId - ID do usuário
   * @returns {Promise}
   */
  removeMember(id, userId) {
    return api.delete(`/api/teams/${id}/members/${userId}`)
  },

  /**
   * Busca a estrutura hierárquica (organograma) da tenant
   * @returns {Promise} - Retorna { admins: [], managers: [], users: [] }
   */
  getOrganizationChart() {
    return api.get('/api/teams/organogram')
  },
}
